import { toTitleCase } from "@/utils/str"
import { FC } from "react"

interface StatusBadgeProps {
  status: string
}

export const StatusBadge: FC<StatusBadgeProps> = ({ status }) => {
  const getBadgeColor = (status: string) => {
    switch (status.toLowerCase()) {
      case "done":
      case "final":
      case "complete":
        return "badge-green"
      case "in progress":
        return "badge"
      case "partial":
        return "badge-light-green"
      default:
        return "badge-grey"
    }
  }

  return <span className={`${getBadgeColor(status)}`}>{toTitleCase(status) || "Unknown"}</span>
}
